import { combineReducers } from 'redux';

import { documentCard } from './document';

export const docCard = combineReducers({
  documentCard,
});
